import { Navigate, useSearchParams } from "react-router-dom";

const QRCode = () => {
  const [params] = useSearchParams();
  try {
    const info = params.get("info");
    const parsedInfo = JSON.parse(atob(info));
    const refCode = parsedInfo.refCode;
    if (typeof refCode === "string" && refCode.length > 0)
      localStorage.setItem("referral", refCode);
    else throw new Error("Invalid Referral Code.");
  } catch (err) {
    console.error(err);
    localStorage.removeItem("referral");
  } finally {
    return <Navigate to="/login" replace />;
  }
};

export default QRCode;
